import { render } from "./pageSucess.vue?vue&type=template&id=3a228357&scoped=true"
import script from "./pageSucess.vue?vue&type=script&lang=js"
export * from "./pageSucess.vue?vue&type=script&lang=js"

import "./pageSucess.vue?vue&type=style&index=0&id=3a228357&scoped=true&lang=css"

import exportComponent from "/Users/rhylton/Sites/caxias-pedal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a228357"]])

export default __exports__